import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { supabase, isSupabaseConfigured } from "../../lib/supabaseClient";

const LoginArea = () => {
  const navigate = useNavigate();
  const { signIn, applySessionFromAuth } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [pending, setPending] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!isSupabaseConfigured || !supabase) {
      setError(
        "Supabase is not configured. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in .env, then restart npm start."
      );
      return;
    }
    setPending(true);
    const { data, error: err } = await signIn(email.trim(), password);
    if (err) {
      setPending(false);
      setError(err.message);
      return;
    }
    const sess = data?.session;
    const uid = sess?.user?.id;
    if (!uid) {
      setPending(false);
      setError("No session returned. Confirm your email if required.");
      return;
    }

    await applySessionFromAuth(sess);

    const { data: row, error: profErr } = await supabase
      .from("profiles")
      .select("is_admin")
      .eq("id", uid)
      .maybeSingle();

    setPending(false);

    if (profErr) {
      setError(
        `Could not load your profile: ${profErr.message}. Run supabase/schema.sql in the SQL editor.`
      );
      return;
    }
    if (!row) {
      setError(
        "No profile row for this user. In Supabase → SQL run the backfill from schema.sql comments (insert from auth.users), then try again."
      );
      return;
    }
    if (row.is_admin) {
      navigate("/admin/dashboard", { replace: true });
    } else {
      navigate("/member/dashboard", { replace: true });
    }
  };

  return (
    <section id="login_arae" className="section_padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 offset-lg-3 col-md-12 col-sm-12 col-12">
            <div className="section_heading">
              <h3>Login your account</h3>
              <h2>
                Join our
                <span className="color_big_heading"> community</span>
                to help peoples
              </h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 offset-lg-3">
            <div className="author_form_area">
              {error && (
                <div className="alert alert-danger small" role="alert">
                  {error}
                </div>
              )}
              <form id="author_form" onSubmit={onSubmit}>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email"
                    autoComplete="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Password"
                    autoComplete="current-password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <div className="author_submit_form">
                  <button
                    type="submit"
                    className="btn btn_theme btn_md"
                    disabled={pending}
                  >
                    {pending ? "Please wait…" : "Login"}
                  </button>
                  <p>
                    Dont have an account?{" "}
                    <Link to="/register">Register now</Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoginArea;
